<template>
  <div style="width:100%;height:100%;">
    <div v-if="cardDataGet.type!=='placeholder'" :style="{background:cardDataGet.type=='placeholder'?'transparent':'white'}" style="display:flex;flex-direction:column;height:100%;padding: 16px 32px;box-sizing: border-box;border-radius:5px;">
      <div class="bottom-content">
        <el-table
            class="customer-small-height-table"
            ref="cardTable"
            :key="updateCount"
            v-loading="tableData.loading"
            :data="tableData.projectList"
            :height="'100%'"
            :width="'100%'"
            style="width: 100%"
            :span-method="objectSpanMethod"
            :header-cell-style="headCellStyle"
            :cell-style="cellStyleMethod"
        >

          <el-table-column v-if="tableData.header" :label="tableData.header.label">
            <el-table-column
                min-width="120"
                v-if="tableData.header.items&&tableData.header.items.length"
                v-for="columnOne in tableData.header.items"
                :prop="columnOne.key"
                :label="columnOne.label"
                >
              <el-table-column
                  min-width="80"
                  v-if="columnOne.items&&columnOne.items.length"
                  v-for="columnTwo in columnOne.items"
                  :prop="columnTwo.key"
                  :label="columnTwo.label"
              >
                <template #header>
                  <div v-if="columnTwo.label.split('/n').length">

                    {{ columnTwo.label.split('/n')[0] }}<br/> {{ columnTwo.label.split('/n')[1] }}
                  </div>
                  <div v-else>{{columnTwo.label}}</div>
                </template>
                <el-table-column
                    min-width="80"
                    v-if="columnTwo.items&&columnTwo.items.length"
                    v-for="columnThree in columnTwo.items"
                    :prop="columnThree.key"
                >
                  <template #header>
                    <div v-if="columnThree.label.split('/n').length">

                      {{ columnThree.label.split('/n')[0] }}<br/> {{ columnThree.label.split('/n')[1] }}
                    </div>
                    <div v-else>{{columnThree.label}}</div>
                  </template>
                </el-table-column>
              </el-table-column>
            </el-table-column>
          </el-table-column>
        </el-table>
        <!-- 分页控制器 -->
        <div style="display:flex;justify-content: right;margin-top: 16px;">
          <div
              v-if="pageConfig.totalCount!==-1"
              style="padding: 2px 5px;line-height: 28px;font-size: 14px;font-family: 'SourceHanSansSC-Regular'">
            共 <span style="color: #1473E3">{{ pageConfig.totalCount.toLocaleString() }}</span> 条数据
          </div>
          <el-pagination v-if="pageConfig.show" background layout="prev, pager, next" @current-change="pageChange"
                         small
                         hide-on-single-page
                         :page-size="pageConfig.pagesize"
                         :current-page="pageConfig.currentPage" :total="pageConfig.totalCount">
          </el-pagination>
        </div>
      </div>
    </div>


  </div>
</template>

<script>
import {getPerformance, getPermissionTest} from "@/api/api";

export default {
  name: "MutiTable",
  props:["cardData","filterRequestData","needRefresh"],
  data(){
    return {
      updateCount:0,
      tableData:{
        loading:false,
        header:{
          key: "",
          label: ""
        },
        //表格列表相关
        detailLoading: false,
        projectList: [],//表格列表所有数据
        showProjectList:[],//显示的数据
        column_mapper: {},//表头所有列的枚举
        showColoums: [],//当前显示的表头列
        sortColumnName: "",//需要排序的列名
        sortColumnOrder: "",//排序的命令
        totalnums: 10,//所有的数据条数
        pageNumber: 1,//当前页
        fixedList: ['project:project_id', 'project:project_name'],
        pagesize: 10,//一页数据的行数（公用）
        pagination:true,
        tableColumnCustomConfig:{//图表某些列定制化显示
          'project:project_id':{
            type:"popover",
            showRule:{
              key:"project:project_remark",
              value:"异常"
            },
            project_id:"",
            closeTime:1,
            openTime:0,
            forceClose:false,
            show:false,
            popoverDatas:[]
          }
        }
      },
      cardDataGet:[],
      pageConfig:{
        show:false,
        totalCount:-1,
        pagesize:10,
        currentPage:1,
      }
      // cardData:{
      //   title:"",
      //   showColoums:[
      //     {
      //       prop:"dept:collaborative_p_dept",
      //       label:"名称:varchar"
      //     },
      //     {
      //       prop:"number:collaborative_p_dept",
      //       label:"订单数:varchar",
      //     },
      //     {
      //       prop:"amount:charge",
      //       label:"金额:varchar",
      //     },
      //     {
      //       prop:"amount:yearonyear",
      //       label:"同比:varchar",
      //     },
      //     {
      //       prop:"amount:chainratio",
      //       label:"环比:varchar",
      //     },
      //   ],
      //   tableData: [{
      //     "dept:collaborative_p_dept": "数字化渠道事业部",
      //     "number:collaborative_p_dept": 15,
      //     "amount:charge":1200000,
      //     "amount:yearonyear":20,
      //     "amount:chainratio":-10
      //   }],
      // }

    }

  },
  mounted() {
    this.cardDataGet = this.cardData
    this.upproject_typeCard()
  },

  watch:{
    needRefresh(newValue){
      // console.log('needRefresh')
      this.upproject_typeCard()
    },
    filterRequestData(newValue){
      // console.log('filterRequestData change，更新cardTable')
      this.upproject_typeCard()

    }
  },
  methods:{
    objectSpanMethod({ row, column, rowIndex, columnIndex }) {
      if (columnIndex === 0) {
        if (rowIndex % 6 === 0) {
          return {
            rowspan: 6,
            colspan: 1
          };
        } else {
          return {
            rowspan: 0,
            colspan: 0
          };
        }
      }
    },
    getCurrentPageDatas(){
      if(this.cardDataGet.type=='placeholder'){
        return
      }
      if(this.cardDataGet.tableDataAll.length > this.pageConfig.pagesize){
        this.cardDataGet.tableData = this.cardDataGet.tableDataAll.slice((this.pageConfig.currentPage-1)*this.pageConfig.pagesize,(this.pageConfig.currentPage)*this.pageConfig.pagesize)
        this.pageConfig.show = true
      }else{
        this.cardDataGet.tableData = this.cardDataGet.tableDataAll
        this.pageConfig.show = false
      }
      // console.log('this.cardDataGet.tableData.length',this.cardDataGet.tableDataAll.length)
      this.pageConfig.totalCount = this.cardDataGet.tableDataAll.length
      this.pageConfig.currentPage = 1
      // console.log('this.cardDataGet.tableData',this.cardDataGet.tableData)
    },

    pageChange(currentPage){
      // console.log('pageChange',currentPage)
      this.pageConfig.currentPage = currentPage;
      this.getCurrentPageDatas()
    },

    upproject_typeCard(){
      if(this.cardDataGet.type!=='placeholder'){
        this.getPerformanceData()
      }
    },
    async getPerformanceData(){
      this.tableData.loading = true
      this.pageConfig.totalCount = -1
        let postData = {
          division: "sale",
          timerange:{
            end:this.filterRequestData.time
          }
        }
        // console.log('mutiTable/postData',postData)
        let res = await getPerformance(postData)
      let resData = res.data.respData
      try {
        this.tableData.projectList = resData.data
        this.tableData.header = resData.columns_list
        this.updateCount += 1
        this.$nextTick(()=>{
          this.$refs.cardTable.doLayout()
          this.tableData.loading = false
        })
      }catch (e) {
        this.$message.error("获取销售数据表失败",e)
      }

        // content.total = resData instanceof Array && resData.length ? resData[0].amount : 0

    },

    /**
     * 表格某行点击
     * @param e 点击item数据
     */
    rowClick(e) {
      this.$emit('row-click',e)
    },

    /**
     * 表格头部样式
     * @param row
     * @param column
     * @param rowIndex
     * @param columnIndex
     * @returns {{fontFamily: string, whiteSpace: string, color: string, textAlign: string, background: string, fontSize: string, boxSizing: string, paddingLeft: string, fontWeight: string, height: string}}
     */
    headCellStyle({row, column, rowIndex, columnIndex}) {
      if(rowIndex==0){
        //销售数据表头
        return {
          lineHeight: '20px',
          background: '#E4E9F4',
          textAlign: 'center',
          fontFamily: 'SourceHanSansSC-Regular, SourceHanSansSC',
          color: '#3F464E',
          fontWeight: 'bolder',
          fontSize: '20px',
          boxSizing: "border-box",
          whiteSpace: "pre",
          padding:"5px 0"
        }
      }else{
        return {
          lineHeight: '20px',
          background: '#E4E9F4',
          textAlign: 'center',
          fontFamily: 'SourceHanSansSC-Regular, SourceHanSansSC',
          color: '#3F464E',
          fontWeight: 'bolder',
          fontSize: '10px',
          boxSizing: "border-box",
          whiteSpace: "pre",
          padding:0
        }
      }
      // let type = this.cardData.showColoums[columnIndex].label.split(":")[1]
      // console.log('表头',rowIndex,columnIndex,type)
      //
      // let fixedHeader = false
      //
      //   if (type === 'decimal' || type === 'int') {
      //
      //
      //     return {
      //       cursor: fixedHeader ? 'no-drop':'grab',
      //       height: '40px',
      //       background: '#E4E9F4',
      //       textAlign: 'right',
      //       fontFamily: 'SourceHanSansSC-Regular, SourceHanSansSC',
      //       color: '#3F464E',
      //       fontWeight: '600',
      //       fontSize: '14px',
      //       paddingLeft: '10px',
      //       boxSizing: "border-box",
      //       whiteSpace: "pre"
      //     }
      //   } else {
      //     return {
      //       cursor: fixedHeader ? 'no-drop':'grab',
      //       height: '40px',
      //       background: '#E4E9F4',
      //       textAlign: 'left',
      //       fontFamily: 'SourceHanSansSC-Regular, SourceHanSansSC',
      //       color: '#3F464E',
      //       fontWeight: '600',
      //       fontSize: '14px',
      //       paddingLeft: '10px',
      //       boxSizing: "border-box",
      //       whiteSpace: "pre"
      //     }
      //   }

    },

    cellStyleMethod({row, column, rowIndex, columnIndex}) {
      let background = "white"
      if(JSON.stringify(this.tableData.projectList[rowIndex]).indexOf('合计')!==-1){
          background= "#E4E9F4"
      }

      if (columnIndex==0) {
        return {
          textAlign: 'center',
          background:background,
          padding:0
        }
      }else if(columnIndex==1){
        return {
          textAlign: 'left',
          background:background,
          padding:0
        }
      } else {
        return {
          textAlign: 'right',
          background:background,
          padding:0
        }
      }


      // let type = this.cardData.showColoums[columnIndex].label.split(":")[1]
        // let fontWeight = 400


        // if (type === 'decimal' || type === 'int') {
        //   return {
        //     // height: '68px',
        //     // background: rowIndex%2===0?'#FFFFFF':'#F6F8FB',
        //     textAlign: 'right',
        //     paddingLeft: '10px',
        //     // fontFamily: 'Helvetica',
        //     // color: '#3F464E',
        //     // fontWeight: fontWeight,
        //     // fontSize: '14px',
        //     // paddingRight: '10px',
        //     // paddingLeft: '20px',
        //     // boxSizing: "border-box",
        //     // lineHeight: "17px"
        //   }
        // } else {
        //   return {
        //     // height: '68px',
        //     // background: rowIndex%2===0?'#FFFFFF':'#F6F8FB',
        //     textAlign: 'left',
        //     paddingLeft: '10px',
        //     // fontFamily: 'Helvetica',
        //     // color: '#3F464E',
        //     // fontWeight: fontWeight,
        //     // fontSize: '14px',
        //     // paddingLeft: '20px',
        //     // boxSizing: "border-box",
        //     // lineHeight: "17px"
        //   }
        // }

    },

    columnsMin(item) {
      let min = 50
      // console.log('item.prop',item.prop)
      if (item.prop === 'dept:collaborative_p_dept') {
        return '130px'
      }else if (item.prop === 'number:order_count') {
        return '65px'
      }else if (item.prop === 'amount:charge') {
        return '78px'
      }else {
        return `${min}px`
      }
    },

    toQfNumber(totype, value, scrop,columData) {
      // console.log('totype',totype,value,scrop,columData)
      let label = columData.label
      let type = label.slice(label.lastIndexOf(':') + 1)
      // console.log('typeValue',type,value)
      if (type === "decimal" || type === 'int') {
        if (value === undefined || !value) {
          return 0
        }

        let nums = value.toFixed(2).toString().split('.')
        nums[0] = parseFloat(nums[0]).toLocaleString()
        return nums[0]
      }
      return value
    },
  }
}
</script>

<style scoped lang="scss">
.left-top-title{
  font-size:40px;
  line-height: 40px;
}
.bottom-content{
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  justify-content: space-around;
  height: calc(100% - 60px);
  margin-top: 20px;
  width: 100%;
}
.right-item{
  display:flex;
  font-weight: 600;
  .title{
    width:50px;
    text-align: right;
  }

}

</style>

<style lang="scss">

.customer-small-height-table td,.customer-no-border-table.el-table th.is-leaf {
  //border:none;
}




.customer-small-height-table::before{
  width: 0;
}

/*去掉鼠标悬停背景颜色*/
.customer-small-height-table.el-table tbody tr:hover>td {
  background-color:#ffffff!important
}

.customer-small-height-table{
  .el-table__row {
    background: #FFFFFF;

  }
  .el-table__row>td{
    //border:none;
  }
  .el-table.el-table__cell{
    background: #3C903F;
    padding:0 !important;
  }
}



</style>

